import { render, staticRenderFns } from "./BulkSummaryStrip.vue?vue&type=template&id=066e36bc"
import script from "./BulkSummaryStrip.vue?vue&type=script&lang=js"
export * from "./BulkSummaryStrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports